module.exports = require('./dist');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-invisible-recaptcha/index.js
// module id = 1585
// module chunks = 7